import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  constructor(private http: HttpClient) {}

  verifyLogin(encryptUserId, options?): Observable<any> {
    console.log('Encrypt ID:', typeof(encryptUserId));
    return this.http
      .post(
        environment.baseURL + 'retailers/loginaccess',
        {
          encryptUserId: encryptUserId,
        },
        options
      )
      .pipe(map(({ response }: any) => response));
  }
}
